import * as React from "react";
import { useTranslation } from 'react-i18next';
import AuditList from "./audit-list/AuditList";

import "./AuditMain.css";

const AuditMain = () => {
    const { t } = useTranslation();
    return (
        <div className="audit-main main-section">
            <div className="audit-main__header">{t('common.audit')}</div>
            <AuditList />
        </div>
    );
}

export default AuditMain;
